import { EnvironmentProviders, Provider } from '@angular/core';
import { provideTwaRedirectorWithCookies } from '@bcf-v2-utilities/twa-redirector-with-cookies/twa-redirector-with-cookies-provider';

export function envAppProvidersTwa(): (Provider | EnvironmentProviders)[] {
  return [provideTwaRedirectorWithCookies()];
}
